import { createApp } from "vue";
import App from "./App.vue";
import "primevue/resources/themes/aura-light-blue/theme.css";
import "./style.css";
import PrimeVue, { defaultOptions } from "primevue/config";
import ToastService from "primevue/toastservice";
import Toast from "primevue/toast";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import Dropdown from "primevue/dropdown";
import Calendar from "primevue/calendar";
import RadioButton from "primevue/radiobutton";
import Textarea from "primevue/textarea";
import MultiSelect from "primevue/multiselect";

// Srpski (latinica) locale — spaja se preko PrimeVue podrazumijevanog,
// tako da ključevi koje ne prevodimo (aria labele i sl.) ostaju definisani.
const serbianLocale = {
  ...defaultOptions.locale,
  firstDayOfWeek: 1,
  dayNames: ['Nedelja', 'Ponedeljak', 'Utorak', 'Sreda', 'Četvrtak', 'Petak', 'Subota'],
  dayNamesShort: ['Ned', 'Pon', 'Uto', 'Sre', 'Čet', 'Pet', 'Sub'],
  dayNamesMin: ['Ne', 'Po', 'Ut', 'Sr', 'Če', 'Pe', 'Su'],
  monthNames: ['Januar', 'Februar', 'Mart', 'April', 'Maj', 'Jun', 'Jul', 'Avgust', 'Septembar', 'Oktobar', 'Novembar', 'Decembar'],
  monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Avg', 'Sep', 'Okt', 'Nov', 'Dec'],
  today: 'Danas',
  clear: 'Obriši',
  dateFormat: 'dd/mm/yy',
  chooseYear: 'Izaberite godinu',
  chooseMonth: 'Izaberite mjesec',
  chooseDate: 'Izaberite datum',
  prevDecade: 'Prethodna decenija',
  nextDecade: 'Sljedeća decenija',
  prevYear: 'Prethodna godina',
  nextYear: 'Sljedeća godina',
  prevMonth: 'Prethodni mjesec',
  nextMonth: 'Sljedeći mjesec',
  emptyFilterMessage: 'Nema rezultata',
  emptySearchMessage: 'Nema rezultata',
  emptyMessage: 'Nema dostupnih opcija',
  emptySelectionMessage: 'Ništa nije izabrano',
  searchMessage: 'Dostupno rezultata: {0}',
  selectionMessage: 'Izabrano: {0}',
  aria: {
    ...defaultOptions.locale.aria,
    close: 'Zatvori',
    previous: 'Prethodno',
    next: 'Sljedeće',
    selectAll: 'Sve stavke su izabrane',
    unselectAll: 'Nijedna stavka nije izabrana',
  },
};

const app = createApp(App);
app.use(PrimeVue, { locale: serbianLocale });
app.use(ToastService);
app.component("Toast", Toast);
app.component("Button", Button);
app.component("InputText", InputText);
app.component("Dropdown", Dropdown);
app.component("Calendar", Calendar);
app.component("RadioButton", RadioButton);
app.component("Textarea", Textarea);
app.component("MultiSelect", MultiSelect);
app.mount("#app");
